/* Publish by EComposer at 2025-08-04 04:42:27*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7o0grb8l86a"]=  window.__ectimmers["ecom-7o0grb8l86a"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-7o0grb8l86a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7o0grb8l86a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sy48xyqs4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sy48xyqs4p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ze01rdjeti').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ze01rdjeti', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kwltju9qohe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kwltju9qohe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-auj0u8t5b0i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-auj0u8t5b0i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-92lax3rrs1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-92lax3rrs1o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-krp1ovx5cz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-krp1ovx5cz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-drgirs6u1wg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-drgirs6u1wg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-if2x8q52oy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-if2x8q52oy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lqml2vn0o4n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lqml2vn0o4n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b8gdkixl6pm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b8gdkixl6pm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6opdtri4rzc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6opdtri4rzc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rlkfr2ir72k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rlkfr2ir72k', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bs4qqua1cs"]=  window.__ectimmers["ecom-bs4qqua1cs"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-bs4qqua1cs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bs4qqua1cs', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c7jvw2pcx7p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c7jvw2pcx7p', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b6zd8x2koj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b6zd8x2koj', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p7t2jk0zee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p7t2jk0zee', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lekm8uzw7p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lekm8uzw7p', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0k2ijw5jt83g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0k2ijw5jt83g', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gcgfcq7945p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gcgfcq7945p', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3auccvp7b9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3auccvp7b9r', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cub62gsi5e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cub62gsi5e', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-segul95x3zm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-segul95x3zm', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0g7ewtigt2cg"]=  window.__ectimmers["ecom-0g7ewtigt2cg"] || {};
const t=this.$el;if(!t)return;let i=this.settings.link_redirect,s=this.settings.hide_form_when_submit||!1,c=t.querySelector('.ecom-contact-form-file[type="file"]');const f=this.id;function p(){if(window.location.href.includes("contact_posted=true")){if(i&&i.href){let o=i.href;if(o=="")return!1;i.target==="_blank"?window.open(o):window.location.href=o}if(s){const o=t.querySelector(".ecom__contact-form-content");o&&(o.style.display="none")}}}p(),window.location.href.includes(s);const n=t.querySelector("#ecom-contact-form-"+f);if(!n)return;const _=n.querySelector(".ecom__form-button");if(!_)return;c&&(n.setAttribute("enctype","multipart/form-data"),n.addEventListener("submit",function(e){if(!c.value||c.value==="")return;e.preventDefault(),e.stopImmediatePropagation(),_.classList.add("ecom-ajax-loading","ecom-loading");const o=n.querySelector('input[type="file"]');let m=new FormData,x=window.location.origin,u=window.EComposer&&window.EComposer.proxy_path;const T=`${x}${u}/contact-form`;m.append("file",o.files[0]),o.value&&u&&fetch(T,{method:"POST",body:m}).then(h=>h.json()).then(h=>{if(h.status==="success"){let L=o.name;o.remove();let $=document.createElement("input");$.value=h.src_file,$.type="hidden",$.name=L,n.appendChild($),n.submit()}else alert(`Notice: ${h.message}`)}).catch(h=>console.error(h)).finally(function(){_.classList.remove("ecom-ajax-loading","ecom-loading")})}),c.addEventListener("change",function(){this.files[0].size>10485760&&(this.value="",alert("File size exceeds the maximum allowed limit (10MB)."))}));let w=t.querySelectorAll(".ecom-required--checkbox");_.addEventListener("click",function(e){w.length>0&&w.forEach(function(o){let m=o.querySelectorAll("input[type=checkbox]");if(m.length==0)return;let x=!1;m.forEach(function(u){u.checked&&(x=!0)}),x?m.forEach(function(u){u.required=!1}):m.forEach(function(u){u.required=!0})})}),n.dataset.ecTrackingId&&n.addEventListener("submit",function(){window.Shopify&&window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:n.id,tracking_id:n.dataset.ecTrackingId})},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-0g7ewtigt2cg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0g7ewtigt2cg', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 $(".file-upload-wrapper").insertAfter(".ecom__form-fields")
} catch(error){console.error(error);}